import axios from "axios";
import queryString from 'query-string';
import {API_KEY_CLIENT, API_SECRET_KEY} from "../env";

export async function refreshIdToken() {
  return new Promise(async function (resolve, reject) {
    console.log('Getting into promise');
    const pathToken = 'https://upgrademe.auth.eu-west-1.amazoncognito.com/oauth2/token';
    var basicAuth = 'Basic ' + btoa(API_KEY_CLIENT + ':' + API_SECRET_KEY);
    var data = {
      'grant_type': 'refresh_token',
      'client_id': API_KEY_CLIENT,
      'refresh_token': localStorage.refresh_token
    };
    localStorage.id_token = await axios.post(pathToken, queryString.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': basicAuth
      }
    }).then(res => {
      // console.log('Refresh process ', res.data);
      return res.data.id_token
    }).catch(function (error) {
      console.log('Error on authentication', error);
      return 'error'
    });
    console.log("Refreshed the Id token successfully")
    if (localStorage.id_token !== 'error') {
      resolve("Stuff worked!");
    } else {
      reject(Error("It broke"));
    }
  })
}

